// mantine
import { Highlight } from '@mantine/core';
// components
import { ILevel } from '@newo/api/gateway';
import LogItem from '@/modules/Analytics/components/SystemOutput/components/LogItem';
// utils
import { linkify } from '@/utils';

interface SystemLogItemProps {
    datetime: string;
    level: ILevel;
    message: string;
    searchTerm?: string;
}

const SystemLogItem = ({
    datetime,
    level,
    message,
    searchTerm
}: SystemLogItemProps) => {
    return (
        <LogItem datetime={datetime} level={level} type="system">
            {searchTerm ? (
                <Highlight
                    className="whitespace-normal"
                    highlight={searchTerm}
                    lineClamp={1}
                    size="xs"
                >
                    {message}
                </Highlight>
            ) : (
                <div
                    className="line-clamp-1"
                    dangerouslySetInnerHTML={{
                        __html: linkify(message)
                    }}
                />
            )}
        </LogItem>
    );
};

export default SystemLogItem;
